/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_sep_hyphen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hyphen (-)`)
};

const es_sg_sep_hyphen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guión (-)`)
};

const de_sg_sep_hyphen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bindestrich (-)`)
};

const nl_sg_sep_hyphen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koppelteken (-)`)
};

const fr_sg_sep_hyphen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiret (-)`)
};

const it_sg_sep_hyphen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trattino (-)`)
};

const pt_br2_sg_sep_hyphen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hífen (-)`)
};

const pt_sg_sep_hyphen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hífen (-)`)
};

const ja_sg_sep_hyphen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハイフン (-)`)
};

const zh_sg_sep_hyphen = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连字符 (-)`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_sep_hyphen = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_sep_hyphen(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_sep_hyphen", locale)
	if (locale === "en") return en_sg_sep_hyphen(inputs)
	if (locale === "es") return es_sg_sep_hyphen(inputs)
	if (locale === "de") return de_sg_sep_hyphen(inputs)
	if (locale === "nl") return nl_sg_sep_hyphen(inputs)
	if (locale === "fr") return fr_sg_sep_hyphen(inputs)
	if (locale === "it") return it_sg_sep_hyphen(inputs)
	if (locale === "pt-BR") return pt_br2_sg_sep_hyphen(inputs)
	if (locale === "pt") return pt_sg_sep_hyphen(inputs)
	if (locale === "ja") return ja_sg_sep_hyphen(inputs)
	return zh_sg_sep_hyphen(inputs)
};